import styled from "styled-components";

const LabelStyle = styled.label`
  color: ${props => props.theme.greyXXXDark};
`;

export { LabelStyle };



// WEBPACK FOOTER //
// ./src/components/Label/style.js